import { render, staticRenderFns } from "./campaigns-edit-page.vue?vue&type=template&id=4a2fe346&"
import script from "./campaigns-edit-page.vue?vue&type=script&lang=js&"
export * from "./campaigns-edit-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports